// extracted by mini-css-extract-plugin
export default {"container":"AddEditBranchDialogContent_container__fQ-nD","root":"AddEditBranchDialogContent_root__q-qxc","fullWidth":"AddEditBranchDialogContent_fullWidth__mZBSl"};